import { render, staticRenderFns } from "./TmNotification.vue?vue&type=template&id=b4c024f4&"
import script from "./TmNotification.vue?vue&type=script&lang=js&"
export * from "./TmNotification.vue?vue&type=script&lang=js&"
import style0 from "./TmNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports